
<div id="thanks-banner" class="font-rubik flex flex-col min-w-0 min-h-0">
  <a id="close-thanks-banner"><img src="@/images/cookies/close.svg" alt="Close" @click="handleClose" /></a>
  <h4 id="thanks-header" class="mb-5">
    Thank You!<br>
    Your {{type == 'reservation' ? 'order was reserved' : 'quote was submitted'}}.
  </h4>
  <p>We've sent you an email with your reservation details to <b>{{ this.closedQuote.customer.email }}</b>.</p>
  <p>We will be following up to finalize your delivery details and schedule a date & time.</p>
  <p class="mb-5">If you have any questions or would like to modify your order please contact us.</p>


  <div class="flex md:justify-end flex-col-reverse md:flex-row text-center gap-4">
    <a
      href="/solutions/container-sales"
      class="underline text-[1rem] font-bold pt-3 md:mr-4 mb-2"
    >
      See Other Containers
    </a>


    <button
      v-if="paymentLink"
      @click="handlePayNow"
      class="border border-[#4D84FF] rounded-full h-[2.75rem] px-5 bg-[#4D84FF] text-white text-[1rem] w-full md:w-auto mb-2"
    >
      Pay Now
    </button>

    <button
      class="border border-[#4D84FF] rounded-full h-[2.75rem] px-5 bg-[#4D84FF] text-white text-[1rem] w-full md:w-auto mb-2"
      @click="handleClose"
    >
      Close Message
    </button>
  </div>
</div>
